import { guidesPacketInformation } from 'modules/common/utils';

export const formatDentistDetailsValuesBeforeSubmit = (values, session) => ({
  ...values,
  sessionId: session?.id,
  guideId: guidesPacketInformation?.id, // this guide is the packet
});
